import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Attachment\RenameDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/RenameDossierAttachmentController.php
* @route '/api/dossier/{dossier}/{media}/attachment-rename'
*/
const RenameDossierAttachmentController = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: RenameDossierAttachmentController.url(args, options),
    method: 'put',
})

RenameDossierAttachmentController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/{media}/attachment-rename',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\Attachment\RenameDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/RenameDossierAttachmentController.php
* @route '/api/dossier/{dossier}/{media}/attachment-rename'
*/
RenameDossierAttachmentController.url = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return RenameDossierAttachmentController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Attachment\RenameDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/RenameDossierAttachmentController.php
* @route '/api/dossier/{dossier}/{media}/attachment-rename'
*/
RenameDossierAttachmentController.put = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: RenameDossierAttachmentController.url(args, options),
    method: 'put',
})

export default RenameDossierAttachmentController